import { Container, Card, Accordion } from 'react-bootstrap'; 
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import '../../styles/_careers.scss';
import jobData from '../../data/jobData';

function JobListings() {
  return (
    <div className="careers-page my-3">
      {/* Hero Section */}
      <Container>
        {/* Job Listings */}
        <h2 className="mb-4 mt-5 text-center animate__animated animate__fadeIn pb-5">Current Openings</h2>
        <Accordion defaultActiveKey="0">
          <TransitionGroup>
            {jobData.length > 0 ? ( // Directly map over jobData
              jobData.map((job, index) => (
                <CSSTransition
                  key={job.id}
                  timeout={500}
                  classNames="job-item"
                >
                  <Card className="mb-3 shadow-sm job-card animate__animated animate__fadeInUp">
                    <Accordion.Item eventKey={index.toString()}>
                      <Accordion.Header>
                        <div className="d-flex justify-content-between align-items-center w-100 pe-3">
                          <h5>{job.title}</h5>
                          <span className="text-muted">{job.location} - {job.employmentType}</span>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        {job.about && (
                          <>
                            <h6>About Brand Acumen</h6>
                            <p>{job.about}</p>
                          </>
                        )}
                        <h6>Role Overview</h6>
                        <p>{job.overview}</p>
                        <h6>Key Responsibilities</h6>
                        <ul>
                          {job.responsibilities.map((res, i) => (
                            <li key={i}>{res}</li>
                          ))}
                        </ul>
                        <ul>
                          {job.qualifications.map((qual, i) => (
                            <li key={i}>{qual}</li>
                          ))}
                        </ul>
                        <h6>Why Brand Acumen?</h6>
                        <ul>
                          {job.whyJoin.map((benefit, i) => (
                            <li key={i}>{benefit}</li>
                          ))}
                        </ul>
                        <h6>To Apply:</h6>
                        <p>
                          {job.apply.split('clientservices@brandacumen.co').map((text, partIndex, parts) => (
                            <span key={partIndex}>
                              {text}
                              {partIndex < parts.length - 1 && (
                                <a
                                  href="mailto:clientservices@brandacumen.co"
                                  aria-label="Email client services at clientservices@brandacumen.co"
                                >
                                  clientservices@brandacumen.co
                                </a>
                              )}
                            </span>
                          ))}
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card>
                </CSSTransition>
              ))
            ) : (
              <CSSTransition
                timeout={500}
                classNames="job-item"
              >
                <p className="text-center mt-4">No job openings available at this time.</p> {/* Updated message */}
              </CSSTransition>
            )}
          </TransitionGroup>
        </Accordion>
      </Container>
    </div>
  );
}

export default JobListings;